import SectionPro from '../components/SectionPro';
import FTab from '../components/Tabs';
import styles from './index.module.scss';

const PowerSupport: React.FC = () => {
    const tabItems = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744978023644/%E8%B5%B0%E8%A1%8C%E5%85%85%E9%9B%BB%20(2)%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744978221316/%E8%B5%B0%E8%A1%8C%E5%85%85%E9%9B%BB%20(4)%20(1).jpg',
            tabLabel: '走行充電',
            tabValue: '11',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745399377615/%E3%82%BD%E3%83%BC%E3%83%A9%E3%83%BC%E5%85%85%E9%9B%BB-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744978253222/%E3%82%BD%E3%83%BC%E3%83%A9%E3%83%BC%E5%85%85%E9%9B%BB%20(2)%20(1).jpg',
            tabLabel: 'ソーラー充電',
            tabValue: '22',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745399377256/AC%E5%85%85%E9%9B%BB-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744978263057/AC%E5%85%85%E9%9B%BB%20(2)%20(1).jpg',
            tabLabel: 'AC充電',
            tabValue: '33',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745399377491/%E3%82%BD%E3%83%BC%E3%83%A9%E3%83%BC%EF%BC%8BAC%E5%85%85%E9%9B%BB-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744978273845/%E3%82%BD%E3%83%BC%E3%83%A9%E3%83%BC%EF%BC%8BAC%E5%85%85%E9%9B%BB%20(2)%20(1).jpg',
            tabLabel: 'ソーラー＋AC充電',
            tabValue: '44',
        },
    ];
    return (
        <div
            className={`${styles.PowerSupport} GtmModuleData-section`}
            data-section-id={styles.PowerSupport}
            data-section-title={'4つの急速充電で、車中泊の電力をトータルサポート'}
        >
            <SectionPro
                label="屋内外、移動中問わず電力不足の心配なし"
                title={
                    <span>
                        4つの急速充電で、車中泊の <br />
                        電力をトータルサポート
                    </span>
                }
            >
                <FTab items={tabItems} />
                <div className="footer-text">*充電方式によって電力変換効率などが異なるため、同じ入力値でも充電時間が異なる場合がございます。</div>
            </SectionPro>
        </div>
    );
};

export default PowerSupport;
